var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "27px",
    viewBox: "0 0 18 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i/lightbulb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p/note",
    transform: "translate(-179.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(179.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9087519,19.6443451 L4.09058631,19.6443451 L4.09058631,18.8261647 C4.07500576,17.5052107 3.53627708,16.2445816 2.59265292,15.3201335 C-0.893403112,11.7861372 -0.859645191,6.09702644 2.66775933,2.60437863 C6.1953636,-0.888069493 11.8844744,-0.865098105 15.383714,2.65571465 C18.8827539,6.17672708 18.870569,11.8660377 15.3561484,15.3716693 C14.4305018,16.2827341 13.9091515,17.5271833 13.9087519,18.8261647 L13.9087519,19.6443451 Z",
    fill: "#FFCB5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90876678,21.2807061 L13.0905715,21.2807061 C13.5426082,21.2807061 13.9087519,21.6468498 13.9087519,22.0988866 C13.9087519,22.5507235 13.5426082,22.917067 13.0905715,22.917067 L4.90876678,22.917067 C4.45692984,22.917067 4.09058631,22.5507235 4.09058631,22.0988866 C4.09058631,21.6468498 4.45692984,21.2807061 4.90876678,21.2807061 Z",
    fill: "#62808C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54512772,24.553428 L11.4542105,24.553428 C11.9062473,24.553428 12.272391,24.9195717 12.272391,25.3716084 C12.272391,25.8234454 11.9062473,26.1897889 11.4542105,26.1897889 L6.54512772,26.1897889 C6.09329078,26.1897889 5.72694725,25.8234454 5.72694725,25.3716084 C5.72694725,24.9195717 6.09329078,24.553428 6.54512772,24.553428 Z",
    fill: "#62808C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.272406, 8.189819)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 1.63636094 0 1.63636094 1.63636094 0 1.63636094"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.27272187 1.63636094 4.90908281 1.63636094 4.90908281 11.4545265 6.54544374 11.4545265 6.54544374 1.63636094 8.18180468 1.63636094 8.18180468 0 3.27272187 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.81816561 0 11.4545265 0 11.4545265 1.63636094 9.81816561 1.63636094"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.24541b2fa283ebe1a70e04214a227c97.svg";
export { ForwardRef as ReactComponent };